module.exports = __webpack_public_path__ + "images/cd4888441c74a547a851a10dc398ce1fcb14e75d3d3777c6e48530135698ac36.svg";